<template lang="html">
  <modal name="purchase-license-modal" height="auto" width="416" :adaptive="true" :maxWidth="416" class="purchase-license-modal" @before-open="beforeOpen">
    <div class="modal-container">
      <div class="modal-header">
        Add Licenses
      </div>
      <div class="line-break-gray" />
      <div class="modal-body">
        <div class="error-message gap-24" v-if="errors.payment">
          {{errors.payment}}
        </div>
        <CreditCardForm :stripe="stripePublicKey" />
        <div class="gap-3x" />
        <div class="flex-box">
          <div class="description-section">
            <div class="bold total">Total</div>
          </div>
          <div class="price-section">
            <div class="bold total">${{total}}</div>
          </div>
        </div>
        <div class="gap-1x" />
        <div class="note">
          All your licenses will expire on {{expires.format("M/D/YYYY")}}, which is one year from your {{explainText}}.
        </div>
      </div>
      <div class="line-break-gray" />
      <div class="modal-footer flex-box">
        <div class="cancel-section">
          <SymbiumButton
            kclass="btn-base dialog-btn"
            :isSmall="true"
            :text="'Back'"
            :onClick="back"
          />
        </div>

        <SymbiumButton
          kclass="btn-base continue-add-user"
          :isSmall="true"
          :text="'Purchase'"
          :onClick="purchase"
          :loading="loading"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import CreditCardForm from 'src/components/common/CreditCardForm.vue'
import moment from 'moment'
import EventBus from 'src/components/EventBus.js'

export default {
  components: { SymbiumButton, CreditCardForm },
  data() {
    return {
      numberOfLicenses: 1,
      total: null,
      expires: moment(),
      loading: false,
      couponCode: null,
      errors: {},
      renewed: false,
    }
  },
  methods: {
    beforeOpen(event) {
      this.numberOfLicenses = event.params.numberOfLicenses;
      this.total = event.params.total;
      this.expires = moment(event.params.expires);
      this.loading = false;
      this.couponCode = event.params.couponCode
      this.renewed = event.params.renewed
    },
    requestPaymentMethod(data) {
      this.$addMoreLicenseCreditCardCharage(
        data.token.id,
        this.numberOfLicenses,
        this.couponCode,
        this.afterPurchaseSucessful,
        this.afterPurchaseFailed,
      );
    },
    purchase() {
      if(this.loading) return;
      this.loading = true;
      EventBus.$emit('checkout-cc', this.requestPaymentMethod)
    },
    afterPurchaseSucessful() {
      EventBus.$emit('buildplus-license-purchased')
    },
    afterPurchaseFailed(data) {
      this.errors.payment = data.errors.payment
      this.loading = false;
    },
    back() {
      this.$modal.hide('purchase-license-modal')
      this.$modal.show('new-license-modal', {
        numberOfLicenses: this.numberOfLicenses,
        expires: this.expires,
      })
    },
    onPaymentNotReady() {
      this.loading = false
    }
  },
  computed: {
    stripePublicKey() {
      return process.env.VUE_APP_STRIPE_PUBLIC_KEY;
    },
    explainText() {
      return this.renewed ? 'last renewal date' : 'first purchase date'
    }
  },
  created() {
    EventBus.$on('payment-not-ready', this.onPaymentNotReady)
  },
  beforeDestroy() {
    EventBus.$off('payment-not-ready', this.onPaymentNotReady)
  }
}
</script>

<style lang="scss">

.purchase-license-modal {
  select.number-of-licenses {
    width: 100%;
    margin-bottom: 144px !important;
  }

  .modal-body {
    padding-top: 0 !important;
  }

  .description-section {
    flex-grow: 1;
  }

  .price-section {
    text-align: right;

    .prorated-savings {
      color: #00A992;
    }
  }

  .total {
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -0.18px;
  }

  .note {
    font-size: 12px;
    line-height: 16px;
  }

  .cancel-section {
    flex-grow: 1;
    text-align: left;
  }

  .continue-add-user {
    min-width: 96px;
  }

  .credit-card-inputs {
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.08px;

    .question-group {
      margin: 0;
      width: 100%;

      .element-container {
        width: auto;
      }

      &.cvc, &.expires {
        width: calc(50% - 12px);
        display: inline-block;
      }

      &.expires {
        margin-right: 24px;
      }
    }
  }
}
</style>
